import React from 'react';

import Icon from 'editor/src/component/Icon/index';

interface Props {
  className?: string;
}

function IconImageMask({ className }: Props) {
  return (
    <Icon className={className}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3.75" y="3.75" width="16.5" height="16.5" rx="1" stroke="#212121" strokeWidth="1.5" />
        <ellipse cx="12" cy="12" rx="5.25" ry="6.5" fill="#212121" />
      </svg>
    </Icon>
  );
}

export default IconImageMask;
